import { z } from 'zod';
import { createDateSafe } from '@/utils/dateUtils';
import { brToIsoDate } from '../utils/vacationDates';

const SCOPES = ['national', 'state', 'municipal'] as const;


export const HolidayFormSchema = z.object({
    date: z
        .string({ required_error: 'Informe a data do feriado' })
        .trim()
        .min(1, 'Informe a data do feriado')
        .transform((value) => (value.includes('/') ? brToIsoDate(value) : value))
        .refine((value) => createDateSafe(value) !== null, 'Data inválida'),
    name: z
        .string({ required_error: 'Informe o nome do feriado' })
        .trim()
        .min(3, 'O nome precisa de pelo menos 3 caracteres'),
    scope: z.enum(SCOPES, { required_error: 'Escolha o alcance do feriado' }),
    recurring: z.boolean().default(true),
});

export type HolidayFormValues = z.input<typeof HolidayFormSchema>;
export type HolidayFormData = z.output<typeof HolidayFormSchema>;

export const holidayFormDefaults: HolidayFormValues = {
    date: '',
    name: '',
    scope: 'national',
    recurring: true,
};

export const HOLIDAY_SCOPES = SCOPES;
